module.exports = __webpack_public_path__ + "img/logo.ac0f2e95.png";